module.exports = {
  headConfig: {
    meta: {
      description: 'Shawb Wong的技术博客, 开发心得, 踩坑经历',
      keyword: 'Shawb Wong, javascript, blog, performance',
      favicon: 'https://2img.net/h/i968.photobucket.com/albums/ae170/laughingjacky/BFBD857E-27EE-4A58-8D75-081FB1E38EB7_zpscdgyncyg.jpg',
    },
  },
}
